import { render, staticRenderFns } from "./form-radio.vue?vue&type=template&id=1619c04a&scoped=true&"
import script from "./form-radio.vue?vue&type=script&lang=js&"
export * from "./form-radio.vue?vue&type=script&lang=js&"
import style0 from "./form-radio.vue?vue&type=style&index=0&id=1619c04a&prod&scoped=true&lang=less&"
import style1 from "./form-radio.vue?vue&type=style&index=1&id=1619c04a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1619c04a",
  null
  
)

export default component.exports